import { render, staticRenderFns } from "./GlassJigouInformationModify.vue?vue&type=template&id=6ff52406&scoped=true&"
import script from "./GlassJigouInformationModify.vue?vue&type=script&lang=js&"
export * from "./GlassJigouInformationModify.vue?vue&type=script&lang=js&"
import style0 from "./GlassJigouInformationModify.vue?vue&type=style&index=0&id=6ff52406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff52406",
  null
  
)

export default component.exports